const getNavElement = () => document.querySelector('#navigation-bar nav');

export default class Dimensions {
    static getNavHeight() {
        const navElement = getNavElement();

        return navElement ? navElement.offsetHeight : 0;
    }

    // A fixed or sticky navigation bar overlays the scrolled content and must be compensated in scroll offsets
    static getFixedNavHeight() {
        const navElement = getNavElement();
        const position = navElement ? window.getComputedStyle(navElement).position : null;

        return position === 'fixed' || position === 'sticky' ? navElement.offsetHeight : 0;
    }
}
